export default "__VITE_ASSET__DtBoH0bG__"